import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { useDropzone } from 'react-dropzone'

import { setFiles } from '../../../../../_actions/careplan.actions'

function CarePlanFiles({ carePlan, files, dispatch }) {
  const onDrop = useCallback(acceptedFiles => {
    dispatch(setFiles(acceptedFiles.map(file => file)));
  }, [dispatch]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'image/png, image/jpeg, image/jpg, application/pdf'
  });

  const removeFile = (removeIndex) => {
    dispatch(setFiles(files.filter((attachment, position) => removeIndex !== position)));
  };

  return <>
    {carePlan.status === 'draft' &&
      carePlan.attachments.data.map((attachment, index) => {
        return <p key={index}>{attachment.name}</p>
      })
    }

    {carePlan.status === 'in-progress' &&
      <>
        <div {...getRootProps()} className="bg-light p-4 text-center text-muted border">
          <input {...getInputProps()} />
          {
            isDragActive ?
              <p className="m-0">Drop the files here ...</p> :
              <p className="m-0">Drag 'n' drop files here, or click to select files</p>
          }
        </div>

        <ul>
          {files.map((file, index) => {
            return <li className="list" key={file.path}> {file.path} <a href="!#" onClick={(e) => { e.preventDefault(); removeFile(index) }}>Remove</a></li>
          })}
        </ul>
      </>
    }
  </>
}

const mapStateToProps = state => {
  return {
    files: state.careplan.files,
    carePlan: state.careplan.current
  }
}

export default connect(mapStateToProps)(CarePlanFiles);